/**
 * 2007-2019 PrestaShop.
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2019 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import './blocklayered.scss';
import Sortable from 'sortablejs';

/* eslint-disable no-unused-vars, no-alert */
function checkForm() {
  let isCategorySelected = false;
  let isFilterSelected = false;

  $('#categories-treeview input[type=checkbox]').each(function checkCategoriesCheckboxes() {
    if ($(this).prop('checked')) {
      isCategorySelected = true;
      return false;
    }
    return true;
  });

  $('.filter_list_item input[type=checkbox]').each(function checkFilterListCheckboxes() {
    if ($(this).prop('checked')) {
      isFilterSelected = true;
      return false;
    }
    return true;
  });

  if (!isCategorySelected) {
    alert(translations.no_selected_categories);
    $('#categories-treeview input[type=checkbox]').first().focus();
    return false;
  }

  if (!isFilterSelected) {
    alert(translations.no_selected_filters);
    $('#filter_list_item input[type=checkbox]').first().focus();
    return false;
  }

  return true;
}

$(document).ready(() => {
  $('.ajaxcall').click(function onAjaxCall() {
    if (this.legend === undefined) {
      this.legend = $(this).html();
    }

    if (this.running === undefined) {
      this.running = false;
    }

    if (this.running === true) {
      return false;
    }

    $('.ajax-message').hide();
    this.running = true;

    if (typeof (this.restartAllowed) === 'undefined' || this.restartAllowed) {
      $(this).html(this.legend + translations.in_progress);
      $('#indexing-warning').show();
    }

    this.restartAllowed = false;
    const type = $(this).attr('rel');

    $.ajax({
      url: `${this.href}&ajax=1`,
      context: this,
      dataType: 'json',
      cache: 'false',
      success() {
        this.running = false;
        this.restartAllowed = true;
        $('#indexing-warning').hide();
        $(this).html(this.legend);

        $('#ajax-message-ok span').html(
          type === 'price' ? translations.url_indexation_finished : translations.attribute_indexation_finished,
        );

        $('#ajax-message-ok').show();
      },
      error() {
        this.restartAllowed = true;
        $('#indexing-warning').hide();

        $('#ajax-message-ko span').html(
          type === 'price' ? translations.url_indexation_failed : translations.attribute_indexation_failed,
        );

        $('#ajax-message-ko').show();
        $(this).html(this.legend);
        this.running = false;
      },
    });

    return false;
  });

  $('.ajaxcall-recurcive').each((it, elm) => {
    $(elm).click(function onAjaxRecursiveCall(e) {
      e.preventDefault();

      if (this.cursor === undefined) {
        this.cursor = 0;
      }

      if (this.legend === undefined) {
        this.legend = $(this).html();
      }

      if (this.running === undefined) {
        this.running = false;
      }

      if (this.running === true) {
        return false;
      }

      $('.ajax-message').hide();

      this.running = true;

      if (typeof (this.restartAllowed) === 'undefined' || this.restartAllowed) {
        $(this).html(this.legend + translations.in_progress);
        $('#indexing-warning').show();
      }

      this.restartAllowed = false;

      $.ajax({
        url: `${this.href}&ajax=1&cursor=${this.cursor}`,
        context: this,
        dataType: 'json',
        cache: 'false',
        success(res) {
          this.running = false;
          if (res.result) {
            this.cursor = 0;
            $('#indexing-warning').hide();
            $(this).html(this.legend);
            $('#ajax-message-ok span').html(translations.price_indexation_finished);
            $('#ajax-message-ok').show();
            return;
          }

          this.cursor = parseInt(res.cursor, 10);
          $(this).html(this.legend + translations.price_indexation_in_progress.replace('%s', res.count));
          $(this).click();
        },
        error(res) {
          this.restartAllowed = true;
          $('#indexing-warning').hide();
          $('#ajax-message-ko span').html(translations.price_indexation_failed);
          $('#ajax-message-ko').show();
          $(this).html(this.legend);

          this.cursor = 0;
          this.running = false;
        },
      });
      return false;
    });
  });

  if (typeof PS_LAYERED_INDEXED !== 'undefined' && PS_LAYERED_INDEXED) {
    $('#url-indexe').click();
    $('#full-index').click();
  }

  /*$('.sortable').sortable({
    forcePlaceholderSize: true,
    handle:'.main_move'
  });*/
  $('.sortable').each(function(){
    Sortable.create(this,{
      group: 'shared',
      ghostClass: "sortable-ghost",
      filter: '.filtered',
      onEnd: function (evt) {
        if($(evt.to).hasClass('disabled_filters')){
          $(evt.item).find('.kaiguan').val('');
          $(evt.item).find('.filter_zhuangtai').val(0);
        }else{
          var show_more_index = $(evt.to).find('> .filtered_show_more').index();
          $(evt.item).find('.kaiguan').val('on');
          $(evt.item).find('.filter_zhuangtai').val((evt.newIndex<show_more_index ? 1 : 2));
        }
      },
      handle: '.icon-move'
    });
  });
  $(document).on('click', '.sortable .icon-arrow-right, .sortable .icon-arrow-left', function(){
    var to = $(this).closest('.sortable').hasClass('disabled_filters') ? 1 : 0;
    var otherUL =  to ? $('.enabled_filters') : $('.disabled_filters');
    var _li = $(this).closest('li');
    if(to){
      _li.find('.kaiguan').val('on');
      _li.find('.filter_zhuangtai').val(1);
    }else{
      _li.find('.kaiguan').val('');
      _li.find('.filter_zhuangtai').val(0);
    }
    _li.detach().prependTo(otherUL);
  });
  $('.sortable .filter_list_item').attr('draggable', false);
  $('.sub_sortable').each(function(){
    Sortable.create(this,{
      ghostClass: "sortable-ghost",
      filter: '.filtered',
      onEnd: function (evt) {
        var show_more_index = $(evt.to).find('.filtered_show_more').index();
        var hidden_index = $(evt.to).find('.filtered_hidden').index();
        $(evt.item).find('.item_zhuangtai').val((evt.newIndex<show_more_index ? 0 : (evt.newIndex<hidden_index ? 1 : 2)));
      },
      handle: '.icon-move'
    });
  });

  $('.filter_list_item input[type=checkbox]').click(function onFilterLickItemCheckboxesClicked() {
    const currentSelectedFiltersCount = parseInt($('#selected_filters').html(), 10);

    $('#selected_filters').html(
      $(this).prop('checked') ? currentSelectedFiltersCount + 1 : currentSelectedFiltersCount - 1,
    );
  });


  /*if (typeof window.filters !== 'undefined') {
    const filters = JSON.parse(window.filters);
    let container = null;
    let $el;
    Object.keys(filters).forEach((filter) => {
      $el = $(`#${filter}`);
      $el.prop('checked', true);
      $('#selected_filters').html(parseInt($('#selected_filters').html(), 10) + 1);
      $(`select[name="${filter}_filter_type"]`).val(filters[filter].filter_type);
      $(`select[name="${filter}_filter_show_limit"]`).val(filters[filter].filter_show_limit);
      if (container === null) {
        container = $(`#${filter}`).closest('ul');
        $el.closest('li').detach().prependTo(container);
      } else {
        $el.closest('li').detach().insertAfter(container);
      }

      container = $el.closest('li');
    });
  }*/
  $(document).on('click', '.st_toggle_sub', function(){
      var facet = $(this).closest('.filter_list_item');
      facet.toggleClass('st_open');
      shFilterOptions(facet);
  });

  $(document).on('change', '.bo_fiter_type', function(){
      var facet = $(this).closest('.filter_list_item');
      shFilterOptions(facet);
  });
});
var shFilterOptions = function(facet){
  var type_dom = facet.find('.bo_fiter_type');
  var type = 3;
  if(type_dom.length)
    type = type_dom.val();
  facet.removeClass('filter_list_0 filter_list_1 filter_list_2 filter_list_3 filter_list_4 filter_list_5 filter_list_6 filter_list_7').addClass('filter_list_'+type);
  facet.find('.ft_item').removeClass('ft_show').end().find('.ft_'+type).addClass('ft_show');
};

/*$(document).on('ready', () => {
  const layeredDefaultCategory = $('input[name="by_default_category"]');
  layeredDefaultCategory.on('change', function initializeOptions(event) {
    const elm = $(this);
    
    if (elm.val() === '1') {
      $('input[name="full_tree"][value="0"]').prop('checked', true);
      $('input[name="full_tree"]').prop('disabled', true);
    } else {
      $('input[name="full_tree"]').prop('disabled', false);
    }
  });

  layeredDefaultCategory.filter('[value="1"]').trigger('change');
});*/